import React, {Component, PropTypes} from 'react';
import {Modal} from 'react-bootstrap';

export default class NextSlideConfirmationModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    cancelBtnMessage: PropTypes.string.isRequired,
    continueBtnMessage: PropTypes.string.isRequired
  };

  constructor() {
    super();
    this.state = {};
  }

  handleCancel() {
    this.props.closeModal(false);
  }

  handleContinue() {
    this.props.closeModal(true);
  }

  render() {
    const {showModal, message} = this.props;
    return (
      <Modal show={showModal} onHide={::this.handleCancel} className="spectacle-deck complete-level">
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <p>
            {message}
          </p>

          <button
            className="btn btn-default"
            onClick={::this.handleCancel}>
            {this.props.cancelBtnMessage}
          </button>

          <button
            className="btn btn-default"
            onClick={::this.handleContinue}>
            {this.props.continueBtnMessage}
          </button>

        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/nextSlideConfirmationModal.jsx